module.exports = __webpack_public_path__ + "img/hx-kfapi-w.edef13ec.svg";